import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wide-banner',
  templateUrl: './wide-banner.component.html',
  styleUrls: ['./wide-banner.component.css']
})
export class WideBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/widget/wide-banner/wide-banner.component.ts